import "../styles/ui_components/_tabs.scss"

const ARROW_LEFT = "ArrowLeft"
const ARROW_RIGHT = "ArrowRight"
const TABLIST_SELECTOR = ".ui-component-tabs [role='tablist']"
export const TAB_SELECTOR = ".ui-component-tabs button[role='tab']"

const clampIndex = (i : number, max : number) : number => {
  if (i > max) {
    return 0
  } else if (i < 0) {
    return max
  } else {
    return i
  }
}

const ariaSelected = (tab : HTMLButtonElement) : boolean =>
  tab.hasAttribute("aria-selected") && tab.getAttribute("aria-selected") === "true"

const ariaControls = (tab : HTMLButtonElement) : string =>
  tab.getAttribute("aria-controls") || ""

const deactivateTabs = (tabs : HTMLCollectionOf<HTMLButtonElement>) : void => {
  for (const tab of tabs) {
    const panel = document.getElementById(ariaControls(tab))

    tab.setAttribute("aria-selected", "false")
    tab.setAttribute("tabindex", "-1")
    if (panel) panel.setAttribute("hidden", "")
  }
}

const activateTab = (tab : HTMLButtonElement) : void => {
  const isSelected = ariaSelected(tab)
  const panel = document.getElementById(ariaControls(tab))
  if (isSelected || !panel) return

  const allTabs = tab.parentNode && tab.parentNode.children
  deactivateTabs(allTabs as HTMLCollectionOf<HTMLButtonElement>)

  tab.setAttribute("aria-selected", "true")
  tab.setAttribute("tabindex", "0")
  panel.removeAttribute("hidden")
  tab.focus()
  tab.dispatchEvent(new CustomEvent('tabshown', { detail: { tab, panel } }))
}

const onTabClick = function(this : HTMLButtonElement) : void {
  activateTab(this)
}

const onKeyDown = function(this : HTMLElement, e : KeyboardEvent) : void {
  if (e.key !== ARROW_LEFT && e.key !== ARROW_RIGHT) return

  const tabs = this.querySelectorAll(TAB_SELECTOR) as NodeListOf<HTMLButtonElement>
  const maxIndex = tabs.length - 1
  const focusedTab = document.activeElement as HTMLButtonElement
  const focusedIndex = focusedTab ? [...tabs].indexOf(focusedTab) : 0
  const newIndex = e.key === ARROW_LEFT
    ? clampIndex(focusedIndex - 1, maxIndex)
    : clampIndex(focusedIndex + 1, maxIndex)

  activateTab(tabs[newIndex] as HTMLButtonElement)
}

for (const tablist of document.querySelectorAll(TABLIST_SELECTOR) as NodeListOf<HTMLElement>) {
  tablist.addEventListener("keydown", onKeyDown)

  for (const tab of tablist.querySelectorAll(TAB_SELECTOR)) {
    tab.addEventListener("click", onTabClick)
  }
}
